(function MediaHubComponent($, Adzuki)
{
	"use strict";

	const mediaHubApp = {
		props: {
			inputData: {
				type: Object
			}
		},
		inject: [
			'$inject_baseUri',
			'$inject_agentId',
			'$inject_franchiseId',
			'$inject_mediaHubUri',
			'$inject_section',
			'$inject_fieldOverride',
			'$inject_targetId',
			'$inject_bindKey'
		],
		data() {
			return {
				showModal        : false,
				uploadProps      : {},
				componentToRender: null,
				mediaHubSite     : '',
				files            : [],
				sectionInfo      : [],
				showAlert        : false,
				alertTitle       : '',
				alertMessage     : '',
				alertType        : 'success',
			};
		},
		methods: {
			toggleModal(tab = null) {
				this.showModal = !this.showModal;
				const baseUri     = this.$inject_baseUri;
				const mediaHubUri = this.$inject_mediaHubUri;
				const section     = this.$inject_section;
				const targetId    = this.$inject_targetId;


				let iframeSrc  = mediaHubUri + baseUri + '/Media/cpMediaHub';

				if (section) {
					iframeSrc += `/section:${section}`;
				}

				if (tab) {
					iframeSrc += `/tab:${tab}`;
				}

				if (targetId) {
					iframeSrc += `/targetId:${targetId}`;
				}

				this.mediaHubSite = `
					<iframe 
						src="${iframeSrc}" 
						width="100%"
						height="100%"
						style="height:100%; border:none; display:block;"
						allowfullscreen>
					</iframe>
				`;

			},
			closeModal() {
				this.showModal = false;
			},
			openAlert(type, title, message) {
				this.showAlert    = true;
				this.alertTitle   = title;
				this.alertMessage = message;
				this.alertType    = type;
			},
			// MEDIA-286: a file sent to Home Office for approval is a submission, not an
			// error or a success -- it was not placed, so offer the picker again
			confirmSentForApproval(lead) {
				Adzuki.CustomConfirm({
					title                  : 'Sent for approval',
					content                : `${lead} We'll email you when it's decided.<br><br>Until then, choose an approved image for this spot.`,
					confirm_btn_text       : 'Choose another image',
					cancel_btn_text        : 'Close',
					scrollToPreviousElement: false,
					confirm                : () => this.toggleModal()
				});
			},
			openToast(status, message) {
				let icon;

				if (status === 'success') {
					icon = `
						<span class="fa-stack fa-2x">
							<i class="fas fa-circle fa-stack-2x text-primary"></i>
							<i class="fas fa-check fa-stack-1x"></i>
						</span>
					`;

				} else {
					icon = `
						<span class="fa-stack fa-2x">
							<i class="fas fa-circle fa-stack-2x text-danger"></i>
							<i class="fas fa-times fa-stack-1x"></i>
						</span>
					`;
				}

				toastr.success(message, icon);
			},
			getSectionInfo() {
				const baseUri = this.$inject_baseUri;
				const section = this.$inject_section;
				const url     = `${baseUri}/MediaSection/getSection/${section}`;

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`Error Fetching Media Sections: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						// If data is returned, we set sectionInfo and create the stencilProps to send to the cropper
						if (data) {
							this.sectionInfo = data;
						}
					})
					.catch(error => {
						console.error('Error fetching Media Sections:', error);

					});
				return null;
			},
			handleIframeMessage(event) {
				let modalElement;

				// Verify origin for security
				if (event.origin !== this.$inject_mediaHubUri) {
					return;
				}

				const eventData = event.data || {};
				if (!eventData || eventData.targetId !== this.$inject_targetId) {
					return;
				}

				// Handle different message types
				switch (eventData.type) {
					case 'scrollModalToTop':
						modalElement = document.querySelector('.modal-component-content');
						modalElement.scrollTo({
							top     : 0,
							behavior: 'smooth'
						});
						break;
					case 'MEDIA_SELECTED':
						this.handleMediaSelected(eventData.payload);
						break;
					case 'CLOSE_MODAL':
						this.closeModal();
						break;
					default:
						console.log('Unknown message type:', eventData);
				}
			},
			handleMediaSelected(mediaData) {
				console.log('Media Id selected from iframe:', mediaData);
				const baseUri = this.$inject_baseUri;
				const section = this.$inject_section;

				if (mediaData.status === 'pending') {
					this.closeModal();
					this.confirmSentForApproval('This image is now with Home Office for review.');
					return;
				}

				let url         = baseUri+`/Media/getAssetData`;
				let requestData = new FormData();

				requestData.append('media_id', mediaData.media_id);
				requestData.append('section', section);

				fetch(url, {
						method: 'POST',
						body  : requestData,
					})
					.then(response => {
						console.log('response', response);
						if (!response.ok) {
							throw new Error(`Error Asset: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						console.log('data', data);
						let pendingMessage = [];

						if (data['files']) {
							const files = Array.isArray(data['files']) ? data['files'] : [data['files']];
							this.files.push(...files);
						}

						console.log(this.files);

						if (this.files.length > 0) {
							this.setAssetInput();
						}

						if (data['pending'] && data['pending'].length > 0) {
							const pending = Array.isArray(data['pending']) ? data['pending'] : [data['pending']];
							pendingMessage.push(...pending);
						}

						this.closeModal();

						if (pendingMessage.length > 0) {
							this.confirmSentForApproval(pendingMessage.length === 1
								? 'One image you chose is now with Home Office for review.'
								: `${pendingMessage.length} images you chose are now with Home Office for review.`);
						}
					})
					.catch(error => {
						console.error('Error Fetching Asset Data Conditions:', error);
						return null;
					});
			},
			removeFile(index) {
				this.files.splice(index, 1);
				this.setAssetInput();
			},
			resolveAssetInput() {
				const fieldOverride = this.$inject_fieldOverride;
				const bindKey       = this.$inject_bindKey;

				console.log('resolveAssetInput', fieldOverride, bindKey);

				if (bindKey) {
					const bindMatch = document.querySelector(`input[data-bind-key="${bindKey}"]`);
					console.log('bindKey', bindKey, 'bindMatch', bindMatch);
					if (bindMatch) {
						return bindMatch;
					}
				}

				if (fieldOverride) {
					const fieldMatches = document.querySelectorAll(`input[id*="${fieldOverride}"]`);

					if (fieldMatches.length === 1) {
						return fieldMatches[0];
					}
				}

				return null;
			},
			dispatchAssetInputChange(assetIdInput) {
				if (!assetIdInput) {
					return;
				}

				assetIdInput.dispatchEvent(new Event('change', { bubbles: true }));
			},
			setAssetInput() {
				const assetIdInput  = this.resolveAssetInput();

				console.log('setAssetInput', assetIdInput);

				const uploadLimit = parseInt(this.sectionInfo.upload_limit, 10);

				if (assetIdInput) {
					if (this.files.length > 0) {
						// Parse current input values
						const currentValues = (assetIdInput.value || '')
							.split(',')
							.map(v => v.trim())
							.filter(Boolean);

						// If at or above limit, remove the first currently displayed file from this.files
						// before building newValues, so it won't be included as "new".
						if (currentValues.length >= uploadLimit && currentValues[0]) {
							const firstId = String(currentValues[0]);
							const idxToRemove = this.files.findIndex(f => String(f.id) === firstId);
							if (idxToRemove !== -1) {
								this.files.splice(idxToRemove, 1);
							}
						}

						// Build newValues from the updated this.files
						const newValues = this.files.map(f => f.id);

						// If still at/over limit, overwrite the first slot with the first new value
						if (currentValues.length >= uploadLimit && newValues.length > 0) {
							currentValues[0] = newValues[0];
							assetIdInput.value = currentValues.join(',');
						} else {
							assetIdInput.value = newValues.join(',');
						}
					} else {
						assetIdInput.value = '';
					}

					this.dispatchAssetInputChange(assetIdInput);
				}
			}
		},
		provide() {
			return {
				openToast     : this.openToast,
				formatDate    : this.formatDate,
				getSectionInfo: this.getSectionInfo
			};
		},
		mounted() {
			this.getSectionInfo();
			window.addEventListener('message', this.handleIframeMessage);
		},
		beforeUnmount() {
			window.removeEventListener('message', this.handleIframeMessage);
		}

	};

	Adzuki.MediaHubComponent = {
		init: function init(containerSelector) {
			const $container  = $(containerSelector);

			if ($container.data('vue-initialized')) {
				console.warn('MediaHub component already initialized on this element');
				return;
			}

			const baseUri     = Adzuki.base_uri;
			const agentId     = Adzuki.agent_id;
			const franchiseId = Adzuki.franchise_id;
			const mediaHubUri = Adzuki.mediahub_url;
			const section     = $container.data('section');
			const assetField  = $container.data('field-override');
			const inputData   = $container.data('input-data');
			const bindKey     = $container.data('bind-key');
			const targetId    = 'mh_' + Math.random().toString(36).slice(2) + Date.now();

			let parsedInputData = JSON.parse(atob(inputData));

			// initialize app and register components
			const app = Vue.createApp(mediaHubApp, {
				inputData: parsedInputData
			});

			app.provide('$inject_baseUri', baseUri);
			app.provide('$inject_agentId', agentId);
			app.provide('$inject_franchiseId', franchiseId);
			app.provide('$inject_mediaHubUri', mediaHubUri);
			app.provide('$inject_section', section);
			app.provide('$inject_fieldOverride', assetField);
			app.provide('$inject_targetId', targetId);
			app.provide('$inject_bindKey', bindKey);


			app.component('adzuki-modal', Adzuki.VueComponents.AdzukiModal);
			app.component('adzuki-alert', Adzuki.VueComponents.AdzukiAlert);
			const mountedApp = app.mount(containerSelector);
			$container.data('vue-initialized', true);
			$container.data('vue-app-instance', mountedApp);
		}
	};

	$(document).ready(function documentReady() {
		$('.mh-btn-container').each(function initMediaHubComponent() {
			Adzuki.MediaHubComponent.init(this);
		});
	});


}(jQuery, window.Adzuki || {}));
